import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user_id: false,
    user_data: {},
    activeModal: '',
    activeModalContent: '',
    current_project_id: null,
    projects: [],
    articles: [],
    blocks: [],
    phrases: []
  },
  mutations: {
    SET_CURRENT_USER: ( state, user ) => {

      if( user === false ){
        Vue.set(state, 'user_id', false)
        Vue.set(state, 'user_data', {})

        Vue.set(state, 'current_project_id', null)
        Vue.set(state, 'projects', [])
        Vue.set(state, 'user_data', [])
        Vue.set(state, 'articles', [])
        Vue.set(state, 'blocks', [])
        Vue.set(state, 'phrases', [])
      }
      else {
        Vue.set(state, 'user_id', user.sub)
        Vue.set(state, 'user_data', user)
      }
    },
    SET_ACTIVE_MODAL: ( state, data ) => {
      Vue.set(state, 'activeModal', data)
    },
    SET_ACTIVE_MODAL_CONTENT: ( state, data ) => {
      Vue.set(state, 'activeModalContent', data)
    },
    SET_CURRENT_PROJECT: (state, data) => {
      var userData = JSON.stringify({ user_metadata: {current_project_id: data} })
      Vue.prototype.$userApi.patch('/users/' + Vue.prototype.$auth.userProfile.sub, userData).then((response) => {
        Vue.set(state, 'current_project_id', data)
      }).catch((e) => { console.log(e) })

    },
    SET_ALL_PROJECTS: (state, { projects }) => {
      Vue.set(state, 'projects', projects)
    },
    SET_ALL_PHRASES: (state, { phrases }) => {
      Vue.set(state, 'phrases', phrases)
    }
  },
  actions: {
    GET_ALL_PROJECTS ( {commit} ) {
      Vue.prototype.$spinnaApi.get('/private/projects').then((response) => {
        commit('SET_ALL_PROJECTS', { projects: response.data.data })

        if( this.state.current_project_id === null && Vue.prototype.$auth.userProfile.sub) {
          let first_key = Vue._.findKey(response.data.data, function(o) { return o.id !== 'undefined' })
          commit('SET_CURRENT_PROJECT', first_key)
        }

      }).catch((e) => { console.log(e) })
    },
    GET_ALL_PHRASES ( {commit} ) {
      Vue.prototype.$spinnaApi.get('/private/phrases').then((response) => {
        commit('SET_ALL_PHRASES', { phrases: response.data.data })
      }).catch((e) => { console.log(e) })
    }

  }
});
